import { useContext, useEffect, useState } from 'react';
import { Board } from '../../../components/Board';
import { NavButton } from '../../../components/NavButton';
import { verifyRoutePermissions } from '../../../globalFunctions';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from './styles.module.scss';

export const LogicManagerGeneralReportRoute = () => {
  const [numeroJogadas, setNumeroJogadas] = useState<number>(0);
  const [numeroUsuarios, setNumeroUsuarios] = useState<number>(0);
  const [fasesCompletadas, setFasesCompletadas] = useState<number>(0);
  const [exercicioMaisJogado, setMaisJogado] = useState<any>();
  const [exercicioMenosJogado, setMenosJogado] = useState<any>();
  const [maisAcertos, setMaisAcertos] = useState<any>();
  const [menosAcertos, setMenosAcertos] = useState<any>();
  const navigate = useNavigate();

  const generateReportHTML = () => `
  <html>
    <head>
      <title>Relatório Geral</title>
      <style>
        body { font-family: Arial, sans-serif; padding: 2rem; }
        h1 { text-align: center; }
        .reportSummary, .reportDetails { margin-bottom: 2rem; }
        .reportCard { margin-bottom: 1rem; }
        .cardLabel { font-weight: bold; }
        .detailRow { margin-bottom: 0.5rem; }
        .detailLabel { font-weight: bold; }
      </style>
    </head>
    <body>
      <h1>Relatório Geral</h1>
      <section class="reportSummary">
        <div class="reportCard">
          <span class="cardLabel">Fases jogadas: </span>
          <span class="cardValue">${Number(numeroJogadas).toLocaleString('pt-br')}</span>
        </div>
        <div class="reportCard">
          <span class="cardLabel">Usuários únicos: </span>
          <span class="cardValue">${numeroUsuarios.toLocaleString('pt-br')}</span>
        </div>
        <div class="reportCard">
          <span class="cardLabel">Fases completas: </span>
          <span class="cardValue">${Number(fasesCompletadas).toLocaleString('pt-br')}</span>
        </div>
      </section>
      <section class="reportDetails">
        <div class="detailRow">
          <span class="detailLabel">Exercício mais jogado: </span>
          <span class="detailValue">
            ${exercicioMaisJogado?.exercicio?.name || ''} 
            ${exercicioMaisJogado ? ` (Módulo: ${exercicioMaisJogado.modulo.name})` : ''}
          </span>
        </div>
        <div class="detailRow">
          <span class="detailLabel">Exercício menos jogado: </span>
          <span class="detailValue">
            ${exercicioMenosJogado?.exercicio?.name || ''} 
            ${exercicioMenosJogado ? ` (Módulo: ${exercicioMenosJogado.modulo.name})` : ''}
          </span>
        </div>
        <div class="detailRow">
          <span class="detailLabel">Mais acertos: </span>
          <span class="detailValue">
            ${maisAcertos?.exercicio?.name || ''} 
            ${maisAcertos ? ` (Módulo: ${maisAcertos.modulo.name}) - ${maisAcertos.total_acertos} acertos` : ''}
          </span>
        </div>
        <div class="detailRow">
          <span class="detailLabel">Menos acertos: </span>
          <span class="detailValue">
            ${menosAcertos?.exercicio?.name || ''} 
            ${menosAcertos ? ` (Módulo: ${menosAcertos.modulo.name}) - ${menosAcertos.total_acertos} acertos` : ''}
          </span>
        </div>
      </section>
    </body>
  </html>
`;

  const onPrintReport = () => {
    const iframe = document.getElementById('report-iframe') as HTMLIFrameElement;
    if (iframe?.contentWindow) {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    }
  };

  useEffect(() => {
    verifyRoutePermissions(
      ['auth', 'email.verified', 'not.pending.update', 'logicmanager.classes'],
      navigate
    );
  }, [navigate]);

  useEffect(() => {
    const fetchResponses = async () => {
      try {
        const jogadas = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/generalReport/jogadas`);
        const usuarios = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/generalReport/usuarios`);
        const fasesCompletas = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/generalReport/fasesCompletadas`);
        const maisJogado = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/generalReport/exercicioMaisJogado`);
        const menosJogado = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/generalReport/exercicioMenosJogado`);
        const maisAcertos = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/generalReport/maisAcertos`);
        const menosAcertos = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/generalReport/menosAcertos`);
        setNumeroJogadas(jogadas.data);
        setNumeroUsuarios(usuarios.data);
        setFasesCompletadas(fasesCompletas.data);
        setMaisJogado(maisJogado.data);
        setMenosJogado(menosJogado.data);
        setMaisAcertos(maisAcertos.data);
        setMenosAcertos(menosAcertos.data);
      } catch (err) { }
    };
    fetchResponses();
  }, []);

  const goBackwards = () => {
    navigate('/manager');
  };

  return (
    <div className={styles.wrapper}>
      <Board wrapperClass={styles.board} NOMORECORNERS={true}>

        <button
          className={styles.printButton}
          onClick={onPrintReport}
          style={{ marginBottom: '1rem' }}
        >
          Imprimir Relatório
        </button>
        <iframe
          id="report-iframe"
          srcDoc={generateReportHTML()}
          style={{ display: 'none' }}
          title="Relatório para impressão"
        />

        <h1 className={styles.title}>Relatório Geral</h1>
        <section className={styles.reportSummary}>
          <div className={styles.reportCard}>
            <span className={styles.cardLabel}>Fases jogadas</span>
            <span className={styles.cardValue}>{Number(numeroJogadas).toLocaleString('pt-br')}</span>
          </div>
          <div className={styles.reportCard}>
            <span className={styles.cardLabel}>Usuários únicos</span>
            <span className={styles.cardValue}>{numeroUsuarios.toLocaleString('pt-br')}</span>
          </div>
          <div className={styles.reportCard}>
            <span className={styles.cardLabel}>Fases completas</span>
            <span className={styles.cardValue}>{Number(fasesCompletadas).toLocaleString('pt-br')}</span>
          </div>
        </section>
        <section className={styles.reportDetails}>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Exercício mais jogado:</span>
            <span className={styles.detailValue}>
              {exercicioMaisJogado && exercicioMaisJogado.exercicio.name}
              {exercicioMaisJogado && ` (Módulo: ${exercicioMaisJogado.modulo.name})`}
            </span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Exercício menos jogado:</span>
            <span className={styles.detailValue}>
              {exercicioMenosJogado && exercicioMenosJogado.exercicio.name}
              {exercicioMenosJogado && ` (Módulo: ${exercicioMenosJogado.modulo.name})`}
            </span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Mais acertos:</span>
            <span className={styles.detailValue}>
              {maisAcertos && maisAcertos.exercicio.name}
              {maisAcertos && ` (Módulo: ${maisAcertos.modulo.name})`}
              {maisAcertos && ` - ${maisAcertos.total_acertos} acertos`}
            </span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Menos acertos:</span>
            <span className={styles.detailValue}>
              {menosAcertos && menosAcertos.exercicio.name}
              {menosAcertos && ` (Módulo: ${menosAcertos.modulo.name})`}
              {menosAcertos && ` - ${menosAcertos.total_acertos} acertos`}
            </span>
          </div>
        </section>
      </Board>
      <NavButton
        direction="left"
        style={{ left: '0.4vw', top: '2vw', zIndex: '20' }}
        onClick={goBackwards}
      />
    </div>
  );
};